<div class="carousel-container" [ngStyle]="{'width': containerWidth}">
  <div *ngFor="let pack of packs; let i = index" class="carousel-item" [ngClass]="{'carousel-item--size__l': isBigTile}">
    <app-carousel-item *ngIf="!pack.isHidden" [omapiId]="pack?.omapiId" [pack]="pack" [x]="i" [y]="yIndex"
                       [isBigTile]="isBigTile" [showPromoBadge]="showPromoBadge"
                       [showSubtitle]="showSubtitle && pack?.showSubtitleInCarousel"
                       (selectedCarouselItem)="scrollToSelectedPack($event)">
    </app-carousel-item>
  </div>
</div>
